import React from "react";
import cx from "classnames";
import { Switch, Route, Redirect } from "react-router-dom";

// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// core components
import PortalNavbar from "components/Navbars/PortalNavbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import PropTypes from "prop-types";

import routes from "routes.js";

import styles from "assets/jss/material-dashboard-pro-react/layouts/adminStyle.js";

import usePortalData from "hooks/usePortalData";
import { canAccessPath } from "auth/permissions";

import { useAuth0 } from "@auth0/auth0-react";
import { useHistory } from "react-router-dom";

const logo = require("assets/img/logo-white.svg").default;

const image = require("assets/img/sidebar-4.jpg").default;

var ps;

const useStyles = makeStyles(styles);

export default function Dashboard(props) {
  const { ...rest } = props;
  // states and functions
  const [miniActive, setMiniActive] = React.useState(false);
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const { user } = useAuth0();
  const {
    allAttendance, allDataRequests, allImages, allMembers, allProjects,
    allRegistrations, allStudies, allTentatives, allUsers, userState,
    reloadAttendance, reloadProjects, reloadRegistrations, reloadStudies,
    reloadTentatives, setReloadImagesUsers,
  } = usePortalData(user);

  // styles
  const classes = useStyles();
  const mainPanelClasses =
    classes.mainPanel +
    " " +
    cx({
      [classes.mainPanelSidebarMini]: miniActive,
      [classes.mainPanelWithPerfectScrollbar]:
        navigator.platform.indexOf("Win") > -1,
    });
  // ref for main panel div
  const mainPanel = React.createRef();
  // effect instead of componentDidMount, componentDidUpdate and componentWillUnmount
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false,
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);

    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  });

  // functions for changeing the states from components

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/portal/full-screen-maps";
  };

  const getActiveRoute = (routes) => {
    let activeRoute = "Default Brand Text";
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        let collapseActiveRoute = getActiveRoute(routes[i].views);
        if (collapseActiveRoute !== activeRoute) {
          return collapseActiveRoute;
        }
      } else {
        if (
          window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
        ) {
          return routes[i].name;
        }
      }
    }
    return activeRoute;
  };

  const history = useHistory();
  const goHome = () => {
    let path = `/portal/highlights`;
    history.push(path);
  };

  const getRoutes = (routes) => {
    if (!canAccessPath(userState, props.location.pathname)) {
      goHome();
    }

    return routes.map((prop, key) => {
      if (prop.collapse) {
        return getRoutes(prop.views);
      }
      if (prop.layout === "/portal") {
        return (
          <Route
            path={prop.layout + prop.path}
            render={(props) => (
              <prop.component /// Giving props to child components - the callBack setReload will update this component and cause a new fetch of users when a child component updates
                {...props}
                users={allUsers}
                tentatives={allTentatives}
                members={allMembers}
                projects={allProjects}
                studies={allStudies}
                registrations={allRegistrations}
                attendance={allAttendance}
                dataRequests={allDataRequests}
                images={allImages}
                userInfo={userState}
                reloadImagesUsersCallBack={setReloadImagesUsers}
                reloadTentativesCallBack={reloadTentatives}
                reloadProjectsCallBack={reloadProjects}
                reloadStudiesCallBack={reloadStudies}
                reloadRegistrationsCallBack={reloadRegistrations}
                reloadAttendanceCallBack={reloadAttendance}
              />
            )}
            //component={prop.component}
            key={key}
          />
        );
      } else {
        return null;
      }
    });
  };
  const sidebarMinimize = () => {
    setMiniActive(!miniActive);
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };

  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={"PREVENT"}
        logo={logo}
        userInfo={userState}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={"blue"}
        bgColor={"black"}
        miniActive={miniActive}
        {...rest}
      />
      <div className={mainPanelClasses} ref={mainPanel}>
        <PortalNavbar
          sidebarMinimize={sidebarMinimize.bind(this)}
          miniActive={miniActive}
          brandText={getActiveRoute(routes)}
          handleDrawerToggle={handleDrawerToggle}
          userInfo={userState}
          reloadImagesUsersCallBack={setReloadImagesUsers}
          {...rest}
        />
        {/* On the /maps/full-screen-maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>
              <Switch>
                {getRoutes(routes)}
                <Redirect from="/portal" to="/portal/dashboard" />
              </Switch>
            </div>
          </div>
        ) : (
          <div className={classes.map}>
            <Switch>
              {getRoutes(routes)}
              <Redirect from="/portal" to="/portal/dashboard" />
            </Switch>
          </div>
        )}
        {getRoute() ? <Footer fluid /> : null}
      </div>
    </div>
  );
}

Dashboard.propTypes = {
  location: PropTypes.Object,
};


